import BaseInput from '../BaseSearch/src/input.js'
export default {
  install (Vue) {
    Vue.component(BaseInput.name, BaseInput)
  }
}
